module.exports = __webpack_public_path__ + "static/media/chevron-square-down.c49fc7e6.svg";